import * as api from '../api';
import moment from 'moment';

export class Payment {
    static redirect(d: api.PaymentInfoRedirect) {
        if (d.method.toLowerCase() === 'get' && d.requestParameters.length === 0) {
            window.location.href = d.url;
        }
        else {
            const form: HTMLFormElement = window.document.createElement('form');

            form.method = d.method;
            form.action = d.url;

            for (let i = 0; i < d.requestParameters.length; i++) {
                const p = d.requestParameters[i];
                const input = window.document.createElement('input');
                input.value = p.paramValue;
                input.name = p.paramName;
                input.type = 'hidden';
                form.appendChild(input);
            }

            window.document.body.appendChild(form);

            // Wait for DOM issues.
            setTimeout(function () {
                form.submit();
            }, 1000);
        }
    }

    static calcMoneyWallPrice(amount: number, departureDate: moment.Moment) {
        const loanContractEndDate = moment().add(60, 'days');
        const k = departureDate.isAfter(loanContractEndDate)
            ? 1.1
            : 1.21;

        return Math.round((amount * k) / 3);
    }
}
